import { some } from 'lodash'

export const getUniquePackageItems = (packageItems = [], activePackageIndex) =>
    packageItems?.reduce((acc, curr) => {
        if (!curr?.personalizedAnnouncementItems && curr.displayName !== 'freeProducts') {
            const productCategoriesQuantity = curr?.displayQtyByPackageOsr[activePackageIndex]
            const isItemAlreadyPresent = some(acc, ['name', curr.displayName])

            if (!isItemAlreadyPresent) {
                acc.push({ name: curr.displayName, quantity: productCategoriesQuantity })
            }
        }

        return acc
    }, [])

export const getUniquePackageItemsWithSubProducts = (packageItems = [], activePackageIndex) =>
    packageItems?.reduce((acc, curr) => {
        if (!!curr?.personalizedAnnouncementItems) {
            const productCategoriesQuantity = curr?.displayQtyByPackageOsr[activePackageIndex]
            const isItemAlreadyPresent = some(acc, ['name', curr.displayName])

            const item = {
                name: curr.displayName,
                quantity: productCategoriesQuantity,
            }

            const subItems = curr.personalizedAnnouncementItems?.filter((subProduct) =>
                subProduct?.prodCatItem === activePackageIndex
            )

            item.subItems = subItems

            if (!isItemAlreadyPresent) {
                acc.push(item)
            }
        }

        return acc
    }, [])

export const getUniquePackagesByDisplayName = (items = []) => items?.reduce((acc, curr) => {
    const isItemAlreadyExisted = Boolean(acc.find((item) => item.displayName === curr.displayName))

    if (!isItemAlreadyExisted) acc.push(curr)

    return acc
}, [])